import React from "react"
import {Button, Container, Grid, Typography} from "@mui/material";
import Footer from "../../components/Footer";
import "./styles.css"
import {AppState} from "../../interfaces/interfaces";

export default function TemplateStarAc(props: any) {

    const {fieldDisplay, appState} = props

    const [message, setMessage] = React.useState<string>('');
    const [phone, setPhone] = React.useState<string>('');

    React.useEffect(() => {
        if (!!fieldDisplay.message) setMessage(fieldDisplay.message)
        if (!!fieldDisplay.phone) setPhone(fieldDisplay.phone)
    }, [fieldDisplay])

    const styles = {
        container: {
            paddingLeft: "0px!important",
            paddingRight: "0px!important"
        },
        header: {
            container: {
                backgroundImage: "url('/assets/starAcademy/header-1.jpg')",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
            },
            stack: {
                height: "100%",
            },
            image: {
                padding: "32px 12px 32px 12px",
                width: "auto",
                maxWidth: "100%",
                maxHeight: "60%",
            },
            text: {
                fontFamily: "draftd",
                fontSize: 32,
                color: "white"
            }
        },
        gridContainer: { textAlign: "center" },
        paragraph1: {
            pt: 5,
            px: 2,
            fontFamily: "draftb-regular",
            fontWeight: "800!important",
            color: "#000",
        },
        button: {
            fontFamily: "draftd",
            backgroundColor: "#ffc04d",
            my: 3,
            py: 2,
            px: 5,
            "&:hover": {
                backgroundColor: "#ffc04d"
            }
        },
        paragraph2: {
            text: {
                px: 2,
                fontFamily: "draftd",
                color: "#000",
                fontSize: 17
            },
            link: {
                px: 2,
                fontFamily: "draftd",
                color: "#000",
                fontSize: 17
            }
        }
    }

    // action and SMS content
    const to: string = encodeURIComponent(phone);
    let bodySms: string = message ? encodeURIComponent(message) : "";
    if (bodySms === "undefined") {
        bodySms = "";
    }
    const _hrefSms: string = `sms:${to}?body=${bodySms}`;

    // renders
    const renderActiveVote = () => {
        return (
            <>
                {/* HEADER */}
                <Grid item xs={12}>
                    <Typography sx={styles.paragraph1}>
                        Vous allez voter par SMS en appuyant sur le bouton ci-dessous
                    </Typography>
                </Grid>
                {/* BUTTON */}
                <Grid item xs={12}>
                    <Button
                        variant={"contained"} disableElevation
                        sx={styles.button}
                        href={_hrefSms}
                    >
                        VOTER PAR SMS
                    </Button>
                </Grid>
                {/* SUBTITLE */}
                <Grid item xs={12}>
                    <Typography variant={"body2"} sx={styles.paragraph2.text}>
                        0,99€ + PRIX SMS<br/>
                        VOTE PAR SMS DISPONIBLE UNIQUEMENT EN FRANCE MÉTROPOLITAINE<br/>
                    </Typography>
                    <Typography
                        component={"a"}
                        href={"https://www.tf1.fr/tf1/gagnants-reglements-remboursement-des-jeux-tv/news/star-academy-gagnants-et-reglement-jeux-et-votes-98498093.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={styles.paragraph2.link}
                    >
                        MODALITÉS ET TERRITOIRES DU VOTE SUR TF1+
                    </Typography>
                </Grid>
            </>
        )
    }

    const renderClosedVote = () => {
        return (
            <Grid item xs={12}>
                <Typography sx={styles.paragraph1}>
                    Le vote est actuellement fermé.<br/>
                    À bientôt !
                </Typography>
            </Grid>
        )
    }

    return (
        <Container maxWidth={false} sx={styles.container}>
            <Grid container spacing={2} sx={styles.gridContainer}>
                {/* IMAGE */}
                <Grid item container xs={12} sx={styles.header.container}>
                    <Grid item xs={5} alignContent="center">
                        <img
                            src={"/assets/starAcademy/logo-2.png"}
                            height={"100%"}
                            width={"auto"}
                            alt={"Logo Secret Story"}
                            style={styles.header.image}
                        />
                    </Grid>
                    <Grid item xs={7} alignContent="center">
                        <Typography sx={styles.header.text}>LE VOTE</Typography>
                    </Grid>
                </Grid>

                {appState === AppState.OPENED ? renderActiveVote() : appState === AppState.CLOSED ? renderClosedVote() : <></>}

                <Footer />
            </Grid>
        </Container>
    )
}